import { IPartner } from 'clickNgo/entities/partner/models'

export const DUPLICATES_CHECK_FIELDS: Array<keyof IPartner> = [
  'locationId',
  'parentLocationId',
  'communicationName',
  'companyLegalName',
  'taxId',
  'country',
  'state',
  'city',
  'addressLine1',
  'addressLine2',
  'addressLine3',
  'zipCode',
  'url',
  'storeNumber',
]
